/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2024-05-14 (jhoward)
 *		- Refactor DineTime widget code from lazy.js to DineTimeWidget.ts.
 *		- Add "title" attribute to DineTime iframe elements.
 *		- Set focus to DineTime iframe elements when they are displayed.
 *		- Return focus to last active element when DineTime iframe elements are closed.
 */
$(function () {

  let dineTimeLastActiveElement = null as HTMLElement | null;

  //@ts-ignore
  function handleDineTimeActivation($dimeTimeOverlayElement: jQuery<HTMLDivElement>) {

    window.showLoader(false);

    $dimeTimeOverlayElement
      .eq(0)
      .removeAttr('aria-hidden')
      .addClass('active');

    setTimeout(function () {

      $dimeTimeOverlayElement
        .eq(0)
        .find('iframe')
        .css({
          minHeight: parseInt($dimeTimeOverlayElement.eq(0).height(), 10) + 1
        });
      setTimeout(() => {
        $dimeTimeOverlayElement.find('iframe')[0].contentWindow.focus();
      }, 500);

    }, 250);

  }

  function handleDineTimeDeactivation() {
    window.hideLoader(true, false);

    $dineTimeOverlayElements
      .removeClass('active')
      .attr('aria-hidden', 'true');

    setTimeout(() => {
      if (dineTimeLastActiveElement) {
        dineTimeLastActiveElement.focus();
        dineTimeLastActiveElement = null;
      }
    }, 500);
  }

  function findDineTimeOverlayElement(pageID: number) {
    return $dineTimeOverlayElements.filter(function () {
      return parseInt($(this).data('page-id'), 10) === pageID;
    });
  }

  function handleDineTimeButtonClick(this: HTMLAnchorElement, event: MouseEvent) {
    const $btn = $(this);
    const $overlayElement = findDineTimeOverlayElement(parseInt($btn.data('page-id'), 10));

    if ($overlayElement.length) {
      event.preventDefault();
      event.stopPropagation();	//stop the overlay from closing due to bubbling of this event

      dineTimeLastActiveElement = this;

      location.hash = 'DINETIME-' + $btn.data('page-id');
    }
  }

  const $dineTimeOverlayElements = $('body').children('.dinetime-overlay');

  $dineTimeOverlayElements
    .on('click', function () {
      location.hash = 'reset';
    });

  $('.page-links')
    .find('.item')
    .find('.dinetime-reservation')
    //@ts-ignore
    .on('click', handleDineTimeButtonClick);

  $('.right-side-content')
    .find('.btn')
    .filter('.dinetime-reservation')
    //@ts-ignore
    .on('click', handleDineTimeButtonClick);

  $(document)
    .on('keydown', function (event) {

      if (event.which === 27) {

        var theHash = location.hash.replace('#', '');

        if (/^DINETIME\-[0-9]{1,5}$/.test(theHash)) {

          window.location.hash = 'reset';

        }

      }

    });


  $(window)
    .on('hashchange.dinetime', function (event) {

      var theHash = location.hash.replace('#', '');

      if (theHash === '' || theHash === 'reset') {

        handleDineTimeDeactivation();

      } else if (/^DINETIME\-[0-9]{1,5}$/.test(theHash)) {

        var matches = /^DINETIME\-([0-9]{1,5})$/.exec(theHash);

        if (matches) {

          var $overlayElement = findDineTimeOverlayElement(parseInt(matches[1], 10));

          if ($overlayElement.length) handleDineTimeActivation($overlayElement);

        }

      }

    })
    .trigger('hashchange.dinetime');


});

//give DineTime iframe elements a title
$(() => {
  document.querySelectorAll('.dinetime_frame--container').forEach(containerNode => {
    const iframeNode = containerNode.querySelector('iframe');
    let outletTitle = (containerNode as HTMLDivElement).dataset.outletTitle || '';
    if (outletTitle.length) {
      outletTitle = ' for ' + outletTitle;
    }

    if (iframeNode) {
      iframeNode.setAttribute('title', 'Make a reservation' + outletTitle);
    } else {
      const observer = new MutationObserver((mutationList, observer) => {
        for (let i = 0, l = mutationList.length; i < l; i++) {
          for (let ii = 0, ll = mutationList[i].addedNodes.length; ii < ll; ii++) {
            if (mutationList[i].addedNodes[ii].nodeName === 'IFRAME') {
              (mutationList[i].addedNodes[ii] as HTMLElement).setAttribute('title', 'Make a reservation' + outletTitle);
              observer.disconnect();
            }
          }
        }
      });
      observer.observe(containerNode, {attributes: true, childList: true, subtree: true});
    }
  });
});